import { render, staticRenderFns } from "./update-awards.vue?vue&type=template&id=7b046c0b&scoped=true&"
import script from "./update-awards.vue?vue&type=script&lang=js&"
export * from "./update-awards.vue?vue&type=script&lang=js&"
import style0 from "./update-awards.vue?vue&type=style&index=0&id=7b046c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b046c0b",
  null
  
)

export default component.exports